export const COMPANY_PRODUCTS_TAG_NAME = 'tm-bo-company-products';
export const COMPANY_PRODUCT_LIST_TAG_NAME = 'tm-bo-company-product-list';
export const ACCOUNT_RECON_TAG_NAME = 'tm-bo-account-recon-feature-detail';
export const ACH_COMPANY_DETAIL_TAG_NAME = 'tm-bo-ach-company-detail';
export const ACH_PRODUCT_FEATURE_WRAPPER_TAG_NAME = 'tm-bo-ach-product-feature-wrapper';
export const TO_ACH_COMPANY_DETAIL_WRAPPER_TAG_NAME = 'tm-bo-to-ach-company-detail-wrapper';
export const AGILETICS_WEB_ESCROW_TAG_NAME = 'tm-bo-agiletics-web-escrow-feature-detail';
export const AMPLIFI_LOYALTY_TAG_NAME = 'tm-bo-amplifi-loyalty-feature-detail';
export const CENTRIX_POSITIVE_PAY_SSO_TAG_NAME = 'tm-bo-centrix-positive-pay-sso-feature-detail';
export const BILL_PAY_TAG_NAME = 'tm-bo-bill-pay-feature-detail';
export const ESI_TAG_NAME = 'tm-bo-electronic-statement-interactive-feature-detail';
export const FOREIGN_CURRENCY_WIRE_TAG_NAME = 'tm-bo-foreign-currency-wire-feature-detail';
export const TRANSFER_TAG_NAME = 'tm-bo-internal-transfer-feature-detail';
export const POSITIVE_PAY_TAG_NAME = 'tm-bo-positive-pay-feature-detail';
export const REMOTE_TAG_NAME = 'tm-bo-remote-deposit-capture-feature-detail';
export const REPORTING_TAG_NAME = 'tm-bo-reporting-feature-detail';
export const WIRE_COMPANY_ACCOUNTS_TAG_NAME = 'tm-bo-wire-company-accounts';
export const STOP_PAYMENT_TAG_NAME = 'tm-bo-stop-payment-feature-detail';
export const WAUSAU_E_STATEMENT_TAG_NAME = 'tm-bo-wausau-e-statement-feature-detail';
export const WIRE_WRAPPER_TAG_NAME = 'tm-bo-wire-feature-detail-wrapper';
export const WIRE_TAG_NAME = 'tm-bo-wire-feature-detail';
